<div class="flex flex-col">
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Topic Source &nbsp;*</mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory="choice-filter-modal-item-editor"
             analyticsAction="entity-scope-input">
      <mat-radio-group class="flex flex-col"
                       [(ngModel)]="data.input.topicSource"
                       aria-label="Select an option">
        <mat-radio-button class="m-b-9" value="Existing">Select an existing data source
        </mat-radio-button>
        <mat-radio-button class="m-b-9" value="Custom">Provide a new custom data source

        </mat-radio-button>
      </mat-radio-group>

    </mat-form-field>
  </div>
  <div *ngIf="data.input.topicSource=='Existing'" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Select &nbsp;*</mat-label>
      <mat-select (selectionChange)="onSelectCandidateSourceType()"
                  [(ngModel)]="data.input.selectedCandidateSourceType">
        <mat-option *ngFor="let type of candidateSourceTypes" [value]="type">
          {{type?.toolName}}/{{ type?.sourceHeader}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="data.input.topicSource=='Custom'" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Topic Name</mat-label>
      <input matInput placeholder="Survey title" [(ngModel)]="data.input.name"
             particleAnalytics
             analyticsCategory="add-survey-dialog"
             analyticsAction="Survey-title" required>
    </mat-form-field>
  </div>

</div>


